import React, { useState, useRef, useEffect } from "react";
import { Input } from "reactstrap";
import FilterIcon from "../images/filter-icon.png";
import SearchIcon from "../images/search-icon.png";
import { IoSearch } from "react-icons/io5";
import MultiLevelSelect from "./MultiLevelSelect.js";
import LocationSelector from "./LocationSelecter.js";
import ShiftSelect from "./Shift.js";
import WorkTypeSelect from "./WorkTypeSelect.js";
import Duration from "./Duration.js";
import axios from "axios";
import AppConstants from "../AppConstants";

const Filters = ({ onFilterChange }) => {
  const initialState = {
    searchText: "",
    profession: "",
    certification: [],
    speciality: [],
    locationCity: "",
    locationRadius: "20",
    locationStates: [],
    shift: [],
    workType: "0",
    duration: []
  };

  const inputRef = useRef();

  const [filters, setFilters] = useState(initialState);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const parseParamArray = (param, delimiter = ",") => {
      if (!param) return [];
      if (params.getAll(param).length > 1) return params.getAll(param);
      const raw = params.get(param);
      if (raw)
        return raw
          .split(delimiter)
          .map((s) => decodeURIComponent(s.trim()))
          .filter(Boolean);
      return [];
    };

    setFilters((prev) => ({
      ...prev,
      profession: decodeURIComponent(params.get("profession") || ""),
      certification: parseParamArray("professionType"),
      speciality: parseParamArray("speciality"),
      locationCity: decodeURIComponent(params.get("city") || ""),
      locationRadius: params.get("radius") || "20",
      locationStates: [...parseParamArray("state")],
      workType: params.get("workType") || "0",
      shift: parseParamArray("shift"),
      duration: parseParamArray("duration")
    }));
  }, []);

  const handleInput = (e) => {
    const value = e.target.value;
    setFilters((prev) => {
      return {
        ...prev,
        searchText: value
      };
    });
  };

  const handleApply = async () => {
    // Build the request payload
    const payload = {
      ...filters,
      page: 1,
      sizeperpage: 10,
      sortname: "",
      searchtext: filters.searchText,
      defaultSearchText: "",
      workType: filters.workType,
      state: filters.locationStates,
      cityFullName: filters.locationCity,
      cityState: "",
      shift: filters.shift,
      searchRadius: filters.locationRadius,
      duration: filters.duration,
      startDate: "",
      toStartDate: "",
      profession: filters.profession,
      certification: filters.certification,
      speciality: filters.speciality,
      pinned: false,
      hotJobs: false
    };
    console.log(payload, "payload");

    onFilterChange(payload);
  };

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleSearch = (text) => {
    if (text.trim() === "") {
      // User cleared input: show all
      onFilterChange({ ...filters, searchText: "" });
    } else {
      // Run filter
      onFilterChange({ ...filters, searchText: text });
    }
  };
  return (
    <>
      <div className="tab-left-filter-in">
        <h2 onClick={toggleFilter} style={{ cursor: "pointer" }}>
          <img src={FilterIcon} alt="" />
          <span>Filters</span>
          <span className="filter-toggle">{isFilterOpen ? " -" : " +"}</span>
        </h2>

        <div className={`filter-content ${isFilterOpen ? "open" : "closed"}`}>
          <div className="search-field">
            <Input
              type="text"
              name="searchText"
              placeholder="Search"
              value={(filters && filters.searchText) || ""}
              onChange={handleInput}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch(filters.searchText); // always from filters
                } else if (
                  e.key === "Backspace" &&
                  filters.searchText.trim() === ""
                ) {
                  handleSearch("");
                }
              }}
              innerRef={inputRef}
              className="cursor-pointer"
            />
            <IoSearch
              color="#25408f"
              className="search-icon-clickable"
              onClick={() => handleSearch(inputRef.current.value)}
              style={{
                position: "absolute",
                top: "14px",
                right: "12px",
                fontSize: "20px"
              }}
            />
          </div>

          <div className="select-field">
            <label>Specialties by Profession</label>

            <MultiLevelSelect
              reset={resetKey}
              value={{
                // 👈 force full re-render
                profession: filters.profession,
                certification: filters.certification,
                speciality: filters.speciality
              }}
              onChange={(updates) =>
                setFilters((prev) => ({ ...prev, ...updates }))
              }
            />
          </div>

          <div className="location-block">
            <label>Work Type</label>
            <WorkTypeSelect
              value={filters.workType}
              onChange={(newWorkType) =>
                setFilters((prev) => ({ ...prev, workType: newWorkType }))
              }
            />
          </div>
          <div className="location-block">
            <label>Location</label>
            <LocationSelector
              value={{
                city: filters.locationCity,
                radius: filters.locationRadius,
                states: filters.locationStates
              }}
              onChange={(updates) =>
                setFilters((prev) => ({ ...prev, ...updates }))
              }
            />
          </div>
          <div className="shift-block">
            <label>Shift</label>
            <ShiftSelect
              value={filters.shift}
              onChange={(newShift) =>
                setFilters((prev) => ({ ...prev, shift: newShift }))
              }
            />
          </div>
          {/* <div className="duration-block">
            <label>Duration</label>
            <Duration
              value={filters.duration}
              onChange={(newDuration) =>
                setFilters((prev) => ({ ...prev, duration: newDuration }))
              }
            />
          </div> */}
          <div className="filter-bttn d-flex justify-content-between mt-3">
            <span
              onClick={() => {
                setFilters(initialState);
                setResetKey((prev) => prev + 1); // 👈 trigger MultiLevelSelect reset
                onFilterChange &&
                  onFilterChange({
                    ...initialState,
                    page: 1,
                    sizeperpage: 50,
                    sortname: "",
                    defaultSearchText: "",
                    workType: "0",
                    pinned: false,
                    hotJobs: false
                  });
              }}
              style={{
                color: "#25408f",
                textDecoration: "underline",
                fontWeight: 500,
                cursor: "pointer"
              }}
            >
              Clear
            </span>

            <span
              onClick={handleApply}
              style={{
                color: "#25408f",
                textDecoration: "underline",
                fontWeight: 500,
                cursor: "pointer"
              }}
            >
              Apply
            </span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .filter-toggle {
          display: none;
          font-size: 18px;
          font-weight: bold;
          margin-left: 10px;
        }

        .filter-content {
          transition: all 0.3s ease;
        }

        @media (max-width: 1199.5px) {
          .filter-toggle {
            display: inline;
          }

          .filter-content.closed {
            display: none;
          }

          .filter-content.open {
            display: block;
          }

          .tab-left-filter-in h2 {
            display: flex;
            align-items: center;
            justify-content: end;
            padding: 10px 0;
            // border-bottom: 1px solid #ddd;
            margin-bottom: 15px;
          }
        }

        @media (min-width: 1200px) {
          .filter-content {
            display: block !important;
          }
        }
      `}</style>
    </>
  );
};
export default Filters;
